module.exports = __webpack_public_path__ + "static/img/footer_600.b477bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/footer_600.png
// module id = U8Yh
// module chunks = 0